import React, { useEffect, useState } from 'react';
import { Spin } from 'antd';
import PropTypes from 'prop-types';
import {
  approveReportCommentApi,
  fetchCommentByIdApi,
  fetchReportCommentsApi,
  rejectReportCommentApi,
  StateReport,
} from '../../../../api/posts/report-comment.api';
import { useReportCommentManagementHook } from '../../../../hooks/admin/post/use-report-comment';
import toast from 'react-hot-toast';
import SingleCommentComponent from '../../../../components/post/post-comments/single-comment-component';
import dayjs from 'dayjs';
import { fetchUserProfileByIdApi } from '../../../../api/user-profile/user-profile.api';
import { hiddenCommentApi } from '../../../../api/posts/report-post.apt';
import { blockCommentUser } from '../../../../api/admin/user.api';
import { Check } from 'lucide-react';
import { AdminButton, AdminPageHeader, AdminPillTabs } from '../../ui';
import { KvRow, ReasonPill, ReportKv } from '../report-moderation/ReportParts';

const ManagementReportComment = (props) => {
  const [isRefetch, setIsRefetch] = useState(false);
  const [status, setStatus] = useState(StateReport.Pending);
  const { data, loading } = useReportCommentManagementHook({ isRefetch, status });
  const [lengthPostNotApprove, setLengthPostNotApprove] = useState(0);
  const [lengthPostPublic, setLengthPostPublic] = useState(0);
  const [lengthPostUnCheck, setLengthPostUnCheck] = useState(0);
  const getAllPostApprove = async () => {
    try {
      const { data } = await fetchReportCommentsApi(StateReport.Pending);
      setLengthPostUnCheck(data.length);
    } catch {
      //
    } finally {
      //
    }
  };
  const getAllPostNotApprove = async () => {
    try {
      const { data } = await fetchReportCommentsApi(StateReport.Accepted);
      setLengthPostNotApprove(data.length);
    } catch {
      //
    } finally {
      //
    }
  };
  const getAllPostPublic = async () => {
    try {
      const { data } = await fetchReportCommentsApi(StateReport.Rejected);
      setLengthPostPublic(data.length);
    } catch {
      //
    } finally {
      //
    }
  };
  useEffect(() => {
    getAllPostApprove();
    getAllPostNotApprove();
    getAllPostPublic();
  }, []);

  const handlePost = async (postId, status) => {
    try {
      // await handleAdminPostApi(postId, status);
      setIsRefetch(!isRefetch);
      toast.success('Thành công');
    } catch {
      //
    } finally {
      //
    }
  };
  const getCommentById = async (comment) => {
    fetchCommentByIdApi(comment.commentId, comment.type).then((data) => {
      return data;
    });
  };
  const STATE_TABS = [
    { label: 'Chờ duyệt', value: StateReport.Pending, count: lengthPostUnCheck },
    { label: 'Đã chấp thuận', value: StateReport.Accepted, count: lengthPostNotApprove },
    { label: 'Đã từ chối', value: StateReport.Rejected, count: lengthPostPublic },
  ];

  return (
    <div className="adm-page">
      <AdminPageHeader
        title="Bình luận bị báo cáo"
        description="Xem từng báo cáo rồi quyết định ẩn bình luận hoặc giữ nguyên."
      />

      <section className="adm-stack">
        <AdminPillTabs
          ariaLabel="Lọc trạng thái báo cáo"
          items={STATE_TABS.map((t) => ({ key: t.value, label: t.label, count: t.count }))}
          value={status}
          onChange={(k) => setStatus(k)}
        />

        {loading ? (
          <div className="flex justify-center py-16">
            <Spin size="large" tip="Đang tải..." />
          </div>
        ) : !data || data.length === 0 ? (
          <p className="adm-report-empty">Không có báo cáo nào.</p>
        ) : (
          <div className="adm-stack">
            {data.map((comment, index) => (
              <MyComponent
                key={index}
                comment={comment}
                status={status}
                refetch={() => setIsRefetch(!isRefetch)}
              />
            ))}
          </div>
        )}
      </section>
    </div>
  );
};

const MyComponent = ({ comment, status, refetch }: { comment: any; status: any; refetch?: any }) => {
  const [item, setItem] = useState<any>();
  const [reportByUser, setReportByUser] = useState<any>();
  const handlePostApprove = async (reportId, commentId, userId) => {
    try {
      await approveReportCommentApi(reportId);
      // Chờ kết quả ẩn thật rồi mới báo (trước đây không await và nuốt lỗi).
      await hiddenCommentApi(commentId, reportId, new Date().toISOString(), '0');
      refetch && refetch();
      toast.success('Bình luận đã được ẩn do vi phạm');
    } catch {
      toast.error('Chưa ẩn được bình luận, vui lòng thử lại.');
    } finally {
      //
    }
  };
  const handleRejectReportPost = async (postId) => {
    try {
      await rejectReportCommentApi(postId);
      refetch && refetch();
      toast.success('Không chấp thuận');
    } catch {
      //
    } finally {
      //
    }
  };
  useEffect(() => {
    const handleGetDetailPost = async (commentId, type) => {
      const res = await fetchCommentByIdApi(commentId, type);
      setItem(res);
    };

    const getReportByUserPost = async (postId) => {
      const res = await fetchUserProfileByIdApi(postId);
      setReportByUser(res.data);
    };

    handleGetDetailPost(comment.commentId, comment.type);
    getReportByUserPost(comment.reportedByUserId);
  }, [comment.postId]);

  if (!item) {
    return (
      <div className="adm-report-row flex items-center justify-center py-10">
        <Spin tip="Đang tải..." />
      </div>
    );
  }

  return (
    <div className="adm-report-row">
      <div className="adm-report-row__body">
        {/* Bình luận bị report */}
        <div className="adm-report-row__comment">
          <div className="adm-report-row__label">Bình luận bị report</div>
          <div style={{ marginTop: 4, fontWeight: 600, color: 'var(--adm-heading)' }}>{item.userName}</div>
          <div className="adm-report-row__text">{item.content}</div>
        </div>
        {/* Thông tin report */}
        <ReportKv loose>
          <KvRow label="Người report">
            <span className="adm-report-kv__strong">
              {reportByUser?.fullname ? reportByUser?.fullname : 'Không xác định'}
            </span>
          </KvRow>
          <KvRow label="Thời gian">{dayjs(comment?.updatedAt).format('DD-MM-YYYY')}</KvRow>
          <KvRow label="Lý do">{comment?.reason ? <ReasonPill>{comment.reason}</ReasonPill> : '—'}</KvRow>
          <KvRow label="Nội dung">{comment?.note || '—'}</KvRow>
        </ReportKv>
      </div>
      {status === StateReport.Pending && (
        <div className="adm-report-row__foot">
          <AdminButton variant="outline" size={36} onClick={() => handleRejectReportPost(comment.id)}>
            Không chấp thuận
          </AdminButton>
          <AdminButton
            variant="success"
            size={36}
            icon={<Check size={16} />}
            onClick={() => handlePostApprove(comment.id, comment.commentId, comment.commentOwnerId)}
          >
            Chấp thuận (ẩn bình luận)
          </AdminButton>
        </div>
      )}
    </div>
  );
};
export default ManagementReportComment;
